import React from 'react';
import { Users, Briefcase, FileText, CreditCard } from 'lucide-react';
import AdminLayout from '../components/AdminLayout';

const STATS = [
  { label: 'Toplam Aday', icon: Users, color: '#2F3A8F', bg: 'rgba(47,58,143,0.1)' },
  { label: 'Aktif İlan', icon: Briefcase, color: '#FF6B35', bg: 'rgba(255,107,53,0.1)' },
  { label: 'Bu Hafta Başvuru', icon: FileText, color: '#00C9A7', bg: 'rgba(0,201,167,0.1)' },
  { label: 'Aktif Abonelik', icon: CreditCard, color: '#8B5CF6', bg: 'rgba(139,92,246,0.1)' },
];

const AdminDashboardPage = () => {
  return (
    <AdminLayout title="Genel Bakış">
      <div className="admin-stat-grid">
        {STATS.map(({ label, icon: Icon, color, bg }) => (
          <div className="admin-stat-card" key={label}>
            <div className="icon-wrap" style={{ background: bg }}>
              <Icon color={color} />
            </div>
            <div className="value">—</div>
            <div className="label">{label}</div>
          </div>
        ))}
      </div>

      <div className="admin-panel-card">
        <div className="admin-placeholder">
          <FileText />
          <h3>Veriler yakında burada</h3>
          <p>
            Bu bölümdeki istatistikler backend admin API'leri hazır olduğunda
            gerçek verilerle dolacak. Panel şablonu ve navigasyon kullanıma hazır.
          </p>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboardPage;
